import * as types from "./adminActionType";

// Region Actions - start
export const fetchRegionsRequest = () => ({
  type: types.FETCH_REGIONS_REQUEST,
});
export const fetchRegionsSuccess = (data) => ({
  type: types.FETCH_REGIONS_SUCCESS,
  payload: data,
});
export const fetchRegionsFailure = (data) => ({
  type: types.FETCH_REGIONS_FAILURE,
  payload: data,
});

export const deleteRegionRequest = (regionId, modifiedBy) => ({
  type: types.DELETE_REGION_REQUEST,
  payload: { regionId, modifiedBy },
});
export const deleteRegionSuccess = (regionId) => ({
  type: types.DELETE_REGION_SUCCESS,
  payload: regionId,
});
export const deleteRegionFailure = (error) => ({
  type: types.DELETE_REGION_FAILURE,
  payload: error,
});

export const saveRegionRequest = (regionData, onSuccess = null) => ({
  type: types.SAVE_REGION_REQUEST,
  payload: regionData,
  onSuccess,
});
export const saveRegionSuccess = (region) => ({
  type: types.SAVE_REGION_SUCCESS,
  payload: region,
});
export const saveRegionFailure = (error) => ({
  type: types.SAVE_REGION_FAILURE,
  payload: error,
});

export const fetchRegionByIdRequest = (regionId) => ({
  type: types.FETCH_REGION_BY_ID_REQUEST,
  payload: { regionId },
});
export const fetchRegionByIdSuccess = (region) => ({
  type: types.FETCH_REGION_BY_ID_SUCCESS,
  payload: region,
});
export const fetchRegionByIdFailure = (error) => ({
  type: types.FETCH_REGION_BY_ID_FAILURE,
  payload: error,
});

export const updateRegionRequest = (regionData) => ({
  type: types.UPDATE_REGION_REQUEST,
  payload: regionData,
});
export const updateRegionSuccess = (region) => ({
  type: types.UPDATE_REGION_SUCCESS,
  payload: region,
});
export const updateRegionFailure = (error) => ({
  type: types.UPDATE_REGION_FAILURE,
  payload: error,
});

export const activateDeactivateRegionRequest = (regionId, status, userId) => ({
  type: types.ACTIVATE_DEACTIVATE_REGION_REQUEST,
  payload: { regionId, status, userId },
});
export const activateDeactivateRegionSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_REGION_SUCCESS,
  payload: result,
});
export const activateDeactivateRegionFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_REGION_FAILURE,
  payload: error,
});
// Region Actions - end

// National Actions - start
export const fetchNationalsRequest = () => ({
  type: types.FETCH_NATIONALS_REQUEST,
});
export const fetchNationalsSuccess = (data) => ({
  type: types.FETCH_NATIONALS_SUCCESS,
  payload: data,
});
export const fetchNationalsFailure = (data) => ({
  type: types.FETCH_NATIONALS_FAILURE,
  payload: data,
});

export const deleteNationalRequest = (nationalId, modifiedBy) => ({
  type: types.DELETE_NATIONAL_REQUEST,
  payload: { nationalId, modifiedBy },
});
export const deleteNationalSuccess = (nationalId) => ({
  type: types.DELETE_NATIONAL_SUCCESS,
  payload: nationalId,
});
export const deleteNationalFailure = (error) => ({
  type: types.DELETE_NATIONAL_FAILURE,
  payload: error,
});

export const saveNationalRequest = (nationalData) => ({
  type: types.SAVE_NATIONAL_REQUEST,
  payload: nationalData,
});
export const saveNationalSuccess = (national) => ({
  type: types.SAVE_NATIONAL_SUCCESS,
  payload: national,
});
export const saveNationalFailure = (error) => ({
  type: types.SAVE_NATIONAL_FAILURE,
  payload: error,
});

export const fetchNationalByIdRequest = (nationalId) => ({
  type: types.FETCH_NATIONAL_BY_ID_REQUEST,
  payload: { nationalId },
});
export const fetchNationalByIdSuccess = (national) => ({
  type: types.FETCH_NATIONAL_BY_ID_SUCCESS,
  payload: national,
});
export const fetchNationalByIdFailure = (error) => ({
  type: types.FETCH_NATIONAL_BY_ID_FAILURE,
  payload: error,
});

export const activateDeactivateNationalRequest = (
  nationalId,
  status,
  userId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_NATIONAL_REQUEST,
  payload: { nationalId, status, userId },
});
export const activateDeactivateNationalSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_NATIONAL_SUCCESS,
  payload: result,
});
export const activateDeactivateNationalFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_NATIONAL_FAILURE,
  payload: error,
});
// National Actions - end

// RPCE Actions - start
export const fetchRPCERequest = () => ({
  type: types.FETCH_RPCE_REQUEST,
});
export const fetchRPCESuccess = (data) => ({
  type: types.FETCH_RPCE_SUCCESS,
  payload: data,
});
export const fetchRPCEFailure = (data) => ({
  type: types.FETCH_RPCE_FAILURE,
  payload: data,
});

export const deleteRPCERequest = (RPCEID, modifiedBy) => ({
  type: types.DELETE_RPCE_REQUEST,
  payload: { RPCEID, modifiedBy },
});
export const deleteRPCESuccess = (RPCEID) => ({
  type: types.DELETE_RPCE_SUCCESS,
  payload: RPCEID,
});
export const deleteRPCEFailure = (error) => ({
  type: types.DELETE_RPCE_FAILURE,
  payload: error,
});

export const saveRPCERequest = (rpceData) => ({
  type: types.SAVE_RPCE_REQUEST,
  payload: rpceData,
});
export const saveRPCESuccess = (rpce) => ({
  type: types.SAVE_RPCE_SUCCESS,
  payload: rpce,
});
export const saveRPCEFailure = (error) => ({
  type: types.SAVE_RPCE_FAILURE,
  payload: error,
});

export const fetchRPCEByIdRequest = (RPCEID) => ({
  type: types.FETCH_RPCE_BY_ID_REQUEST,
  payload: { RPCEID },
});
export const fetchRPCEByIdSuccess = (rpce) => ({
  type: types.FETCH_RPCE_BY_ID_SUCCESS,
  payload: rpce,
});
export const fetchRPCEByIdFailure = (error) => ({
  type: types.FETCH_RPCE_BY_ID_FAILURE,
  payload: error,
});

export const activateDeactivateRPCERequest = (RPCEID, status, userId) => ({
  type: types.ACTIVATE_DEACTIVATE_RPCE_REQUEST,
  payload: { RPCEID, status, userId },
});
export const activateDeactivateRPCESuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_RPCE_SUCCESS,
  payload: result,
});
export const activateDeactivateRPCEFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_RPCE_FAILURE,
  payload: error,
});
// RPCE Actions - end

// Worklist Actions
export const fetchWorkListRequest = () => ({
  type: types.FETCH_WORKLIST_REQUEST,
});
export const fetchWorkListSuccess = (data) => ({
  type: types.FETCH_WORKLIST_SUCCESS,
  payload: data,
});
export const fetchWorkListFailure = (error) => ({
  type: types.FETCH_WORKLIST_FAILURE,
  payload: error,
});

export const deleteWorkListRequest = (WorkListID, modifiedBy) => ({
  type: types.DELETE_WORKLIST_REQUEST,
  payload: { WorkListID, modifiedBy },
});
export const deleteWorkListSuccess = (workListId) => ({
  type: types.DELETE_WORKLIST_SUCCESS,
  payload: workListId,
});
export const deleteWorkListFailure = (error) => ({
  type: types.DELETE_WORKLIST_FAILURE,
  payload: error,
});

export const dropdownWorkListRequest = () => ({
  type: types.DROPDOWN_WORKLIST_REQUEST,
});
export const dropdownWorklistSuccess = (data) => ({
  type: types.DROPDOWN_WORKLIST_SUCCESS,
  payload: data,
});
export const dropdownWorklistFailure = (error) => ({
  type: types.DROPDOWN_WORKLIST_FAILURE,
  payload: error,
});

export const saveWorklistRequest = (worklistData) => ({
  type: types.SAVE_WORKLIST_REQUEST,
  payload: worklistData,
});
export const saveWorklistSuccess = (worklist) => ({
  type: types.SAVE_WORKLIST_SUCCESS,
  payload: worklist,
});
export const saveWorklistFailure = (error) => ({
  type: types.SAVE_WORKLIST_FAILURE,
  payload: error,
});

export const fetchWorklistByIdRequest = (worklistId) => ({
  type: types.FETCH_WORKLIST_BY_ID_REQUEST,
  payload: { worklistId },
});
export const fetchWorklistByIdSuccess = (worklist) => ({
  type: types.FETCH_WORKLIST_BY_ID_SUCCESS,
  payload: worklist,
});
export const fetchWorklistByIdFailure = (error) => ({
  type: types.FETCH_WORKLIST_BY_ID_FAILURE,
  payload: error,
});

export const activateDeactivateWorklistRequest = (
  worklistId,
  status,
  userId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_WORKLIST_REQUEST,
  payload: { worklistId, status, userId },
});
export const activateDeactivateWorklistSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_WORKLIST_SUCCESS,
  payload: result,
});
export const activateDeactivateWorklistFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_WORKLIST_FAILURE,
  payload: error,
});

// Worklist Definition Actions
export const fetchWorklistDefinitionRequest = (filters = null) => ({
  type: types.FETCH_WORKLIST_DEFINITION_REQUEST,
  payload: filters,
});
export const fetchWorklistDefinitionSuccess = (data) => ({
  type: types.FETCH_WORKLIST_DEFINITION_SUCCESS,
  payload: data,
});
export const fetchWorklistDefinitionFailure = (error) => ({
  type: types.FETCH_WORKLIST_DEFINITION_FAILURE,
  payload: error,
});

export const dropdownWorklistDefinitionTypeRequest = () => ({
  type: types.DROPDOWN_WORKLIST_DEFINITION_TYPE_REQUEST,
});
export const dropdownWorklistDefinitionTypeSuccess = (data) => ({
  type: types.DROPDOWN_WORKLIST_DEFINITION_TYPE_SUCCESS,
  payload: data,
});
export const dropdownWorklistDefinitionTypeFailure = (error) => ({
  type: types.DROPDOWN_WORKLIST_DEFINITION_TYPE_FAILURE,
  payload: error,
});

export const dropdownWorklistDefinitionFacilityRequest = () => ({
  type: types.DROPDOWN_WORKLIST_DEFINITION_FACILITY_REQUEST,
});
export const dropdownWorklistDefinitionFacilitySuccess = (data) => ({
  type: types.DROPDOWN_WORKLIST_DEFINITION_FACILITY_SUCCESS,
  payload: data,
});
export const dropdownWorklistDefinitionFacilityFailure = (error) => ({
  type: types.DROPDOWN_WORKLIST_DEFINITION_FACILITY_FAILURE,
  payload: error,
});

export const saveWorklistDefinitionRequest = (worklistDefinitionData) => ({
  type: types.SAVE_WORKLIST_DEFINITION_REQUEST,
  payload: worklistDefinitionData,
});
export const saveWorklistDefinitionSuccess = (result) => ({
  type: types.SAVE_WORKLIST_DEFINITION_SUCCESS,
  payload: result,
});
export const saveWorklistDefinitionFailure = (error) => ({
  type: types.SAVE_WORKLIST_DEFINITION_FAILURE,
  payload: error,
});

export const deleteWorklistDefinitionRequest = (workListId, modifiedBy, filters) => ({
  type: types.DELETE_WORKLIST_DEFINITION_REQUEST,
  payload: { workListId, modifiedBy, filters },
});
export const deleteWorklistDefinitionSuccess = (result) => ({
  type: types.DELETE_WORKLIST_DEFINITION_SUCCESS,
  payload: result,
});
export const deleteWorklistDefinitionFailure = (error) => ({
  type: types.DELETE_WORKLIST_DEFINITION_FAILURE,
  payload: error,
});

export const activateDeactivateWorklistDefinitionRequest = (
  workListId,
  status,
  userId,
  filters
) => ({
  type: types.ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_REQUEST,
  payload: { workListId, status, userId, filters },
});
export const activateDeactivateWorklistDefinitionSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_SUCCESS,
  payload: result,
});
export const activateDeactivateWorklistDefinitionFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_FAILURE,
  payload: error,
});

// Worklist Group Actions
export const fetchWorklistGroupRequest = () => ({
  type: types.FETCH_WORKLIST_GROUP_REQUEST,
});
export const fetchWorklistGroupSuccess = (data) => ({
  type: types.FETCH_WORKLIST_GROUP_SUCCESS,
  payload: data,
});
export const fetchWorklistGroupFailure = (error) => ({
  type: types.FETCH_WORKLIST_GROUP_FAILURE,
  payload: error,
});

export const dropdownWorklistGroupWorklistRequest = (worklistGroupId = 0) => ({
  type: types.DROPDOWN_WORKLIST_GROUP_WORKLIST_REQUEST,
  payload: worklistGroupId,
});
export const dropdownWorklistGroupWorklistSuccess = (data) => ({
  type: types.DROPDOWN_WORKLIST_GROUP_WORKLIST_SUCCESS,
  payload: data,
});
export const dropdownWorklistGroupWorklistFailure = (error) => ({
  type: types.DROPDOWN_WORKLIST_GROUP_WORKLIST_FAILURE,
  payload: error,
});

export const saveWorklistGroupRequest = (worklistGroupData) => ({
  type: types.SAVE_WORKLIST_GROUP_REQUEST,
  payload: worklistGroupData,
});
export const saveWorklistGroupSuccess = (result) => ({
  type: types.SAVE_WORKLIST_GROUP_SUCCESS,
  payload: result,
});
export const saveWorklistGroupFailure = (error) => ({
  type: types.SAVE_WORKLIST_GROUP_FAILURE,
  payload: error,
});

export const deleteWorklistGroupRequest = (worklistGroupId, modifiedBy) => ({
  type: types.DELETE_WORKLIST_GROUP_REQUEST,
  payload: { worklistGroupId, modifiedBy },
});
export const deleteWorklistGroupSuccess = (result) => ({
  type: types.DELETE_WORKLIST_GROUP_SUCCESS,
  payload: result,
});
export const deleteWorklistGroupFailure = (error) => ({
  type: types.DELETE_WORKLIST_GROUP_FAILURE,
  payload: error,
});

export const activateDeactivateWorklistGroupRequest = (
  worklistGroupId,
  status,
  userId
) => ({
  type: types.ACTIVATE_DEACTIVATE_WORKLIST_GROUP_REQUEST,
  payload: { worklistGroupId, status, userId },
});
export const activateDeactivateWorklistGroupSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_WORKLIST_GROUP_SUCCESS,
  payload: result,
});
export const activateDeactivateWorklistGroupFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_WORKLIST_GROUP_FAILURE,
  payload: error,
});

export const fetchWorklistDefinitionConfigurationRequest = (filters) => ({
  type: types.FETCH_WORKLIST_DEFINITION_CONFIGURATION_REQUEST,
  payload: filters,
});
export const fetchWorklistDefinitionConfigurationSuccess = (data) => ({
  type: types.FETCH_WORKLIST_DEFINITION_CONFIGURATION_SUCCESS,
  payload: data,
});
export const fetchWorklistDefinitionConfigurationFailure = (error) => ({
  type: types.FETCH_WORKLIST_DEFINITION_CONFIGURATION_FAILURE,
  payload: error,
});

export const fetchWorklistDefinitionConfigurationDropdownsRequest = (
  workListDefinationID,
  workListDefinationSiteMappingId = 0,
) => ({
  type: types.FETCH_WORKLIST_DEFINITION_CONFIGURATION_DROPDOWNS_REQUEST,
  payload: { workListDefinationID, workListDefinationSiteMappingId },
});
export const fetchWorklistDefinitionConfigurationDropdownsSuccess = (data) => ({
  type: types.FETCH_WORKLIST_DEFINITION_CONFIGURATION_DROPDOWNS_SUCCESS,
  payload: data,
});
export const fetchWorklistDefinitionConfigurationDropdownsFailure = (error) => ({
  type: types.FETCH_WORKLIST_DEFINITION_CONFIGURATION_DROPDOWNS_FAILURE,
  payload: error,
});

export const fetchWorklistDefinitionConfigurationByIdRequest = (
  workListDefinationSiteMappingId,
) => ({
  type: types.FETCH_WORKLIST_DEFINITION_CONFIGURATION_BYID_REQUEST,
  payload: { workListDefinationSiteMappingId },
});
export const fetchWorklistDefinitionConfigurationByIdSuccess = (data) => ({
  type: types.FETCH_WORKLIST_DEFINITION_CONFIGURATION_BYID_SUCCESS,
  payload: data,
});
export const fetchWorklistDefinitionConfigurationByIdFailure = (error) => ({
  type: types.FETCH_WORKLIST_DEFINITION_CONFIGURATION_BYID_FAILURE,
  payload: error,
});

export const saveWorklistDefinitionConfigurationRequest = (data) => ({
  type: types.SAVE_WORKLIST_DEFINITION_CONFIGURATION_REQUEST,
  payload: data,
});
export const saveWorklistDefinitionConfigurationSuccess = (result) => ({
  type: types.SAVE_WORKLIST_DEFINITION_CONFIGURATION_SUCCESS,
  payload: result,
});
export const saveWorklistDefinitionConfigurationFailure = (error) => ({
  type: types.SAVE_WORKLIST_DEFINITION_CONFIGURATION_FAILURE,
  payload: error,
});

export const deleteWorklistDefinitionConfigurationRequest = (
  workListDefinationSiteMappingId,
  workListDefinationID,
) => ({
  type: types.DELETE_WORKLIST_DEFINITION_CONFIGURATION_REQUEST,
  payload: { workListDefinationSiteMappingId, workListDefinationID },
});
export const deleteWorklistDefinitionConfigurationSuccess = (result) => ({
  type: types.DELETE_WORKLIST_DEFINITION_CONFIGURATION_SUCCESS,
  payload: result,
});
export const deleteWorklistDefinitionConfigurationFailure = (error) => ({
  type: types.DELETE_WORKLIST_DEFINITION_CONFIGURATION_FAILURE,
  payload: error,
});

export const activateDeactivateWorklistDefinitionConfigurationRequest = (
  workListDefinationSiteMappingId,
  status,
  userId,
  workListDefinationID,
) => ({
  type: types.ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_CONFIGURATION_REQUEST,
  payload: {
    workListDefinationSiteMappingId,
    status,
    userId,
    workListDefinationID,
  },
});
export const activateDeactivateWorklistDefinitionConfigurationSuccess = (
  result,
) => ({
  type: types.ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_CONFIGURATION_SUCCESS,
  payload: result,
});
export const activateDeactivateWorklistDefinitionConfigurationFailure = (
  error,
) => ({
  type: types.ACTIVATE_DEACTIVATE_WORKLIST_DEFINITION_CONFIGURATION_FAILURE,
  payload: error,
});

export const fetchTagCategoryConfigurationRequest = (filters = null) => ({
  type: types.FETCH_TAG_CATEGORY_CONFIGURATION_REQUEST,
  payload: filters,
});
export const fetchTagCategoryConfigurationSuccess = (data) => ({
  type: types.FETCH_TAG_CATEGORY_CONFIGURATION_SUCCESS,
  payload: data,
});
export const fetchTagCategoryConfigurationFailure = (error) => ({
  type: types.FETCH_TAG_CATEGORY_CONFIGURATION_FAILURE,
  payload: error,
});

export const fetchTagCategoryConfigurationByIdRequest = (tagCategoryID) => ({
  type: types.FETCH_TAG_CATEGORY_CONFIGURATION_BYID_REQUEST,
  payload: { tagCategoryID },
});
export const fetchTagCategoryConfigurationByIdSuccess = (data) => ({
  type: types.FETCH_TAG_CATEGORY_CONFIGURATION_BYID_SUCCESS,
  payload: data,
});
export const fetchTagCategoryConfigurationByIdFailure = (error) => ({
  type: types.FETCH_TAG_CATEGORY_CONFIGURATION_BYID_FAILURE,
  payload: error,
});

export const saveTagCategoryConfigurationRequest = (data) => ({
  type: types.SAVE_TAG_CATEGORY_CONFIGURATION_REQUEST,
  payload: data,
});
export const saveTagCategoryConfigurationSuccess = (result) => ({
  type: types.SAVE_TAG_CATEGORY_CONFIGURATION_SUCCESS,
  payload: result,
});
export const saveTagCategoryConfigurationFailure = (error) => ({
  type: types.SAVE_TAG_CATEGORY_CONFIGURATION_FAILURE,
  payload: error,
});

export const activateDeactivateTagCategoryConfigurationRequest = (
  tagCategoryID,
  status,
  userId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_TAG_CATEGORY_CONFIGURATION_REQUEST,
  payload: { tagCategoryID, status, userId },
});
export const activateDeactivateTagCategoryConfigurationSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_TAG_CATEGORY_CONFIGURATION_SUCCESS,
  payload: result,
});
export const activateDeactivateTagCategoryConfigurationFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_TAG_CATEGORY_CONFIGURATION_FAILURE,
  payload: error,
});

export const fetchManageTagsShellRequest = (tagCategoryID) => ({
  type: types.FETCH_MANAGE_TAGS_SHELL_REQUEST,
  payload: { tagCategoryID },
});
export const fetchManageTagsShellSuccess = (data) => ({
  type: types.FETCH_MANAGE_TAGS_SHELL_SUCCESS,
  payload: data,
});
export const fetchManageTagsShellFailure = (error) => ({
  type: types.FETCH_MANAGE_TAGS_SHELL_FAILURE,
  payload: error,
});

export const fetchTagAssignmentsRequest = (
  tagCategoryID,
  tagID,
  resourceTagID,
  loadNonce,
) => ({
  type: types.FETCH_TAG_ASSIGNMENTS_REQUEST,
  payload: { tagCategoryID, tagID, resourceTagID, loadNonce },
});
export const fetchTagAssignmentsSuccess = (
  tagID,
  resourceTagID,
  data,
  loadNonce,
) => ({
  type: types.FETCH_TAG_ASSIGNMENTS_SUCCESS,
  payload: { tagID, resourceTagID, data, loadNonce },
});
export const fetchTagAssignmentsFailure = (
  tagID,
  resourceTagID,
  error,
  loadNonce,
) => ({
  type: types.FETCH_TAG_ASSIGNMENTS_FAILURE,
  payload: { tagID, resourceTagID, error, loadNonce },
});

export const saveManageTagsBatchRequest = (data) => ({
  type: types.SAVE_MANAGE_TAGS_BATCH_REQUEST,
  payload: data,
});
export const saveManageTagsBatchSuccess = (result) => ({
  type: types.SAVE_MANAGE_TAGS_BATCH_SUCCESS,
  payload: result,
});
export const saveManageTagsBatchFailure = (error) => ({
  type: types.SAVE_MANAGE_TAGS_BATCH_FAILURE,
  payload: error,
});

export const saveTagRequest = (data) => ({
  type: types.SAVE_TAG_REQUEST,
  payload: data,
});
export const saveTagSuccess = (result) => ({
  type: types.SAVE_TAG_SUCCESS,
  payload: result,
});
export const saveTagFailure = (error) => ({
  type: types.SAVE_TAG_FAILURE,
  payload: error,
});

export const deleteTagRequest = (data) => ({
  type: types.DELETE_TAG_REQUEST,
  payload: data,
});
export const deleteTagSuccess = (result) => ({
  type: types.DELETE_TAG_SUCCESS,
  payload: result,
});
export const deleteTagFailure = (error) => ({
  type: types.DELETE_TAG_FAILURE,
  payload: error,
});

//-------------dropdowns in Worklist start ----------------

// All master worklist dropdowns

export const dropdownAllMasterWorklistRequest = () => ({
  type: types.DROPDOWN_ALL_MASTER_WORKLIST_REQUEST,
});
export const dropdownAllMasterWorklistSuccess = (data) => ({
  type: types.DROPDOWN_ALL_MASTER_WORKLIST_SUCCESS,
  payload: data,
});
export const dropdownAllMasterWorklistFailure = (error) => ({
  type: types.DROPDOWN_ALL_MASTER_WORKLIST_FAILURE,
  payload: error,
});

// Get Regional Practice Worklist dropdown
export const dropdownRegionalPracticeWorklistRequest = (
  regionalPracticeID,
) => ({
  type: types.DROPDOWN_REGIONAL_PRACTICE_WORKLIST_REQUEST,
  payload: { regionalPracticeID },
});
export const dropdownRegionalPracticeWorklistSuccess = (data) => ({
  type: types.DROPDOWN_REGIONAL_PRACTICE_WORKLIST_SUCCESS,
  payload: data,
});
export const dropdownRegionalPracticeWorklistFailure = (error) => ({
  type: types.DROPDOWN_REGIONAL_PRACTICE_WORKLIST_FAILURE,
  payload: error,
});

//Main Practice
export const dropdownMainPracticeRequest = (regionalPracticeID) => ({
  type: types.DROPDOWN_MAIN_PRACTICE_REQUEST,
  payload: { regionalPracticeID },
});
export const dropdownMainPracticeSuccess = (data) => ({
  type: types.DROPDOWN_MAIN_PRACTICE_SUCCESS,
  payload: data,
});
export const dropdownMainPracticeFailure = (error) => ({
  type: types.DROPDOWN_MAIN_PRACTICE_FAILURE,
  payload: error,
});

//-------------dropdowns in Worklist end ----------------

//----------------------Worklist Actions End-----------------------
// Practice Actions
export const fetchPracticeRequest = () => ({
  type: types.FETCH_PRACTICE_REQUEST,
});
export const fetchPracticeSuccess = (data) => ({
  type: types.FETCH_PRACTICE_SUCCESS,
  payload: data,
});
export const fetchPracticeFailure = (data) => ({
  type: types.FETCH_PRACTICE_FAILURE,
  payload: data,
});

export const fetchPracticeByIdRequest = (practiceId) => ({
  type: types.FETCH_PRACTICE_BY_ID_REQUEST,
  payload: { practiceId },
});
export const fetchPracticeByIdSuccess = (practice) => ({
  type: types.FETCH_PRACTICE_BY_ID_SUCCESS,
  payload: practice,
});
export const fetchPracticeByIdFailure = (error) => ({
  type: types.FETCH_PRACTICE_BY_ID_FAILURE,
  payload: error,
});

export const dropdownWorkListDDRequest = () => ({
  type: types.DROPDOWN_WORKLISTDD_REQUEST,
});
export const dropdownWorkListDDSuccess = (data) => ({
  type: types.DROPDOWN_WORKLISTDD_SUCCESS,
  payload: data,
});
export const dropdownWorkListDDFailure = (error) => ({
  type: types.DROPDOWN_WORKLISTDD_FAILURE,
  payload: error,
});

export const fetchRegionByWorkListIdRequest = (id) => ({
  type: types.DROPDOWN_REGION_BY_WORKLISTID_REQUEST,
  payload: { id },
});
export const fetchRegionByWorkListIdSuccess = (region) => ({
  type: types.DROPDOWN_REGION_BY_WORKLISTID_SUCCESS,
  payload: region,
});
export const fetchRegionByWorkListIdFailure = (error) => ({
  type: types.DROPDOWN_REGION_BY_WORKLISTID_FAILURE,
  payload: error,
});

export const dropdownMasterRegionRequest = () => ({
  type: types.DROPDOWN_MASTER_REGION_REQUEST,
});
export const dropdownMasterRegionSuccess = (region) => ({
  type: types.DROPDOWN_MASTER_REGION_SUCCESS,
  payload: region,
});
export const dropdownMasterRegionFailure = (error) => ({
  type: types.DROPDOWN_MASTER_REGION_FAILURE,
  payload: error,
});

export const dropdownMasterNationalRequest = () => ({
  type: types.DROPDOWN_MASTER_NATIONAL_REQUEST,
});
export const dropdownMasterNationalSuccess = (national) => ({
  type: types.DROPDOWN_MASTER_NATIONAL_SUCCESS,
  payload: national,
});
export const dropdownMasterNationalFailure = (error) => ({
  type: types.DROPDOWN_MASTER_NATIONAL_FAILURE,
  payload: error,
});

export const savePracticeRequest = (practiceData, onSuccess = null) => ({
  type: types.SAVE_PRACTICE_REQUEST,
  payload: practiceData,
  onSuccess,
});
export const savePracticeSuccess = (practice) => ({
  type: types.SAVE_PRACTICE_SUCCESS,
  payload: practice,
});
export const savePracticeFailure = (error) => ({
  type: types.SAVE_PRACTICE_FAILURE,
  payload: error,
});

export const deletePracticeRequest = (practiceId, modifiedBy) => ({
  type: types.DELETE_PRACTICE_REQUEST,
  payload: { practiceId, modifiedBy },
});
export const deletePracticeSuccess = (practiceId) => ({
  type: types.DELETE_PRACTICE_SUCCESS,
  payload: practiceId,
});
export const deletePracticeFailure = (error) => ({
  type: types.DELETE_PRACTICE_FAILURE,
  payload: error,
});

export const activateDeactivatePracticeRequest = (
  PracticeID,
  status,
  userId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_PRACTICE_REQUEST,
  payload: { PracticeID, status, userId },
});
export const activateDeactivatePracticeSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_PRACTICE_SUCCESS,
  payload: result,
});
export const activateDeactivatePracticeFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_PRACTICE_FAILURE,
  payload: error,
});

//Subpractice Actions - start
export const fetchSubpracticeRequest = () => ({
  type: types.FETCH_SUBPRACTICES_REQUEST,
});
export const fetchSubpracticeSuccess = (data) => ({
  type: types.FETCH_SUBPRACTICES_SUCCESS,
  payload: data,
});
export const fetchSubpracticeFailure = (error) => ({
  type: types.FETCH_SUBPRACTICES_FAILURE,
  payload: error,
});

export const deleteSubpracticeRequest = (SubPracticeID, modifiedBy) => ({
  type: types.DELETE_SUBPRACTICE_REQUEST,
  payload: { SubPracticeID, modifiedBy },
});
export const deleteSubpracticeSuccess = (SubPracticeID) => ({
  type: types.DELETE_SUBPRACTICE_SUCCESS,
  payload: SubPracticeID,
});
export const deleteSubpracticeFailure = (error) => ({
  type: types.DELETE_SUBPRACTICE_FAILURE,
  payload: error,
});

export const saveSubpracticeRequest = (subpracticeData, onSuccess = null) => ({
  type: types.SAVE_SUBPRACTICE_REQUEST,
  payload: subpracticeData,
  onSuccess,
});
export const saveSubpracticeSuccess = (subpractice) => ({
  type: types.SAVE_SUBPRACTICE_SUCCESS,
  payload: subpractice,
});
export const saveSubpracticeFailure = (error) => ({
  type: types.SAVE_SUBPRACTICE_FAILURE,
  payload: error,
});

export const fetchSubpracticeByIdRequest = (SubPracticeID) => ({
  type: types.FETCH_SUBPRACTICE_BY_ID_REQUEST,
  payload: { SubPracticeID },
});
export const fetchSubpracticeByIdSuccess = (subpractice) => ({
  type: types.FETCH_SUBPRACTICE_BY_ID_SUCCESS,
  payload: subpractice,
});
export const fetchSubpracticeByIdFailure = (error) => ({
  type: types.FETCH_SUBPRACTICE_BY_ID_FAILURE,
  payload: error,
});

export const activateDeactivateSubpracticeRequest = (
  SubPracticeID,
  status,
  userId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_SUBPRACTICE_REQUEST,
  payload: { SubPracticeID, status, userId },
});
export const activateDeactivateSubpracticeSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_SUBPRACTICE_SUCCESS,
  payload: result,
});
export const activateDeactivateSubpracticeFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_SUBPRACTICE_FAILURE,
  payload: error,
});

export const dropdownSubpracticeRequest = () => ({
  type: types.DROPDOWN_SUBPRACTICE_REQUEST,
});
export const dropdownSubpracticeSuccess = (data) => ({
  type: types.DROPDOWN_SUBPRACTICE_SUCCESS,
  payload: data,
});
export const dropdownSubpracticeFailure = (error) => ({
  type: types.DROPDOWN_SUBPRACTICE_FAILURE,
  payload: error,
});
//Subpractice Actions - end

//SectionWorklist Mapping Actions - start
export const fetchSectionWorklistRequest = () => ({
  type: types.FETCH_SECTIONWORKLIST_REQUEST,
});
export const fetchSectionWorklistSuccess = (data) => ({
  type: types.FETCH_SECTIONWORKLIST_SUCCESS,
  payload: data,
});
export const fetchSectionWorklistFailure = (error) => ({
  type: types.FETCH_SECTIONWORKLIST_FAILURE,
  payload: error,
});

export const deleteSectionWorklistRequest = (SectionID, modifiedBy) => ({
  type: types.DELETE_SECTIONWORKLIST_REQUEST,
  payload: { SectionID, modifiedBy },
});
export const deleteSectionWorklistSuccess = (SectionID) => ({
  type: types.DELETE_SECTIONWORKLIST_SUCCESS,
  payload: SectionID,
});
export const deleteSectionWorklistFailure = (error) => ({
  type: types.DELETE_SECTIONWORKLIST_FAILURE,
  payload: error,
});

export const saveSectionWorklistRequest = (sectionWorklistData, onSuccess = null) => ({
  type: types.SAVE_SECTIONWORKLIST_REQUEST,
  payload: sectionWorklistData,
  onSuccess,
});
export const saveSectionWorklistSuccess = (sectionWorklist) => ({
  type: types.SAVE_SECTIONWORKLIST_SUCCESS,
  payload: sectionWorklist,
});
export const saveSectionWorklistFailure = (error) => ({
  type: types.SAVE_SECTIONWORKLIST_FAILURE,
  payload: error,
});

export const fetchSectionWorklistByIdRequest = (SectionID) => ({
  type: types.FETCH_SECTIONWORKLIST_BY_ID_REQUEST,
  payload: { SectionID },
});
export const fetchSectionWorklistByIdSuccess = (sectionWorklist) => ({
  type: types.FETCH_SECTIONWORKLIST_BY_ID_SUCCESS,
  payload: sectionWorklist,
});
export const fetchSectionWorklistByIdFailure = (error) => ({
  type: types.FETCH_SECTIONWORKLIST_BY_ID_FAILURE,
  payload: error,
});

export const activateDeactivateSectionWorklistRequest = (
  SectionID,
  status,
  userId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_SECTIONWORKLIST_REQUEST,
  payload: { SectionID, status, userId },
});
export const activateDeactivateSectionWorklistSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_SECTIONWORKLIST_SUCCESS,
  payload: result,
});
export const activateDeactivateSectionWorklistFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_SECTIONWORKLIST_FAILURE,
  payload: error,
});

export const dropdownSectionWorklistRequest = () => ({
  type: types.DROPDOWN_SECTIONWORKLIST_REQUEST,
});
export const dropdownSectionWorklistSuccess = (data) => ({
  type: types.DROPDOWN_SECTIONWORKLIST_SUCCESS,
  payload: data,
});
export const dropdownSectionWorklistFailure = (error) => ({
  type: types.DROPDOWN_SECTIONWORKLIST_FAILURE,
  payload: error,
});
//SectionWorklist Mapping Actions - end

// // User Management Actions
// export const fetchUserManagementRequest = () => ({
//     type: types.FETCH_USERMANAGEMENT_REQUEST
// });
// export const fetchUserManagementSuccess = data => ({
//     type: types.FETCH_USERMANAGEMENT_SUCCESS,
//     payload: data
// });
// export const fetchUserManagementFailure = data => ({
//     type: types.FETCH_USERMANAGEMENT_FAILURE,
//     payload: data
// });

// export const deleteUserManagementRequest = (UserId, modifiedBy) => ({
//     type: types.DELETE_USERMANAGEMENT_REQUEST,
//     payload: { UserId, modifiedBy }
// });
// export const deleteUserManagementSuccess = (UserId) => ({
//     type: types.DELETE_USERMANAGEMENT_SUCCESS,
//     payload: UserId
// });
// export const deleteUserManagementFailure = (error) => ({
//     type: types.DELETE_USERMANAGEMENT_FAILURE,
//     payload: error
// });

// export const saveUserManagementRequest = (userData) => ({
//     type: types.SAVE_USERMANAGEMENT_REQUEST,
//     payload: userData
// });
// export const saveUserManagementSuccess = (user) => ({
//     type: types.SAVE_USERMANAGEMENT_SUCCESS,
//     payload: user
// });
// export const saveUserManagementFailure = (error) => ({
//     type: types.SAVE_USERMANAGEMENT_FAILURE,
//     payload: error
// });

// export const activateDeactivateUserManagementRequest = (Id, status, userId) => ({
//     type: types.ACTIVATE_DEACTIVATE_USERMANAGEMENT_REQUEST,
//     payload: { Id, status, userId }
// });
// export const activateDeactivateUserManagementSuccess = (result) => ({
//     type: types.ACTIVATE_DEACTIVATE_USERMANAGEMENT_SUCCESS,
//     payload: result
// });
// export const activateDeactivateUserManagementFailure = (error) => ({
//     type: types.ACTIVATE_DEACTIVATE_USERMANAGEMENT_FAILURE,
//     payload: error
// });

// export const dropdownUserManagementRoleRequest = () => ({
//     type: types.DROPDOWN_USERMANAGEMENTROLE_REQUEST,
// });
// export const dropdownUserManagementRoleSuccess = (data) => ({
//     type: types.DROPDOWN_USERMANAGEMENTROLE_SUCCESS,
//     payload: data
// });
// export const dropdownUserManagementRoleFailure = (error) => ({
//     type: types.DROPDOWN_USERMANAGEMENTROLE_FAILURE,
//     payload: error
// });

// export const dropdownUserManagementDesignationRequest = () => ({
//     type: types.DROPDOWN_USERMANAGEMENTDESIGNATION_REQUEST,
// });
// export const dropdownUserManagementDesignationSuccess = (data) => ({
//     type: types.DROPDOWN_USERMANAGEMENTDESIGNATION_SUCCESS,
//     payload: data
// });
// export const dropdownUserManagementDesignationFailure = (error) => ({
//     type: types.DROPDOWN_USERMANAGEMENTDESIGNATION_FAILURE,
//     payload: error
// });

// export const fetchUserManagementByIdRequest = (userId) => ({
//     type: types.FETCH_USERMANAGEMENT_BY_ID_REQUEST,
//     payload: { userId }
// });
// export const fetchUserManagementByIdSuccess = (user) => ({
//     type: types.FETCH_USERMANAGEMENT_BY_ID_SUCCESS,
//     payload: user
// });
// export const fetchUserManagementByIdFailure = (error) => ({
//     type: types.FETCH_USERMANAGEMENT_BY_ID_FAILURE,
//     payload: error
// });

// export const dropdownTenantsRequest = () => ({
//     type: types.DROPDOWN_TENANTS_REQUEST,
// });
// export const dropdownTenantsSuccess = (data) => ({
//     type: types.DROPDOWN_TENANTS_SUCCESS,
//     payload: data
// });
// export const dropdownTenantsFailure = (error) => ({
//     type: types.DROPDOWN_TENANTS_FAILURE,
//     payload: error
// });

// export const dropdownUserRegionalPracticeRequest = () => ({
//     type: types.DROPDOWN_USER_REGIONAL_PRACTICE_REQUEST,
// });
// export const dropdownUserRegionalPracticeSuccess = (data) => ({
//     type: types.DROPDOWN_USER_REGIONAL_PRACTICE_SUCCESS,
//     payload: data
// });
// export const dropdownUserRegionalPracticeFailure = (error) => ({
//     type: types.DROPDOWN_USER_REGIONAL_PRACTICE_FAILURE,
//     payload: error
// });
// export const dropdownUserMainPracticeRequest = () => ({
//     type: types.DROPDOWN_USER_MAIN_PRACTICE_REQUEST,
// });
// export const dropdownUserMainPracticeSuccess = (data) => ({
//     type: types.DROPDOWN_USER_MAIN_PRACTICE_SUCCESS,
//     payload: data
// });
// export const dropdownUserMainPracticeFailure = (error) => ({
//     type: types.DROPDOWN_USER_MAIN_PRACTICE_FAILURE,
//     payload: error
// });
// // User Management Actions - End

// User Management Actions
export const fetchUserManagementRequest = () => ({
  type: types.FETCH_USERMANAGEMENT_REQUEST,
});
export const fetchUserManagementSuccess = (data) => ({
  type: types.FETCH_USERMANAGEMENT_SUCCESS,
  payload: data,
});
export const fetchUserManagementFailure = (data) => ({
  type: types.FETCH_USERMANAGEMENT_FAILURE,
  payload: data,
});

export const deleteUserManagementRequest = (RADUserID, modifiedBy) => ({
  type: types.DELETE_USERMANAGEMENT_REQUEST,
  payload: { radUserId: RADUserID, modifiedBy },
});
export const deleteUserManagementSuccess = (RADUserID) => ({
  type: types.DELETE_USERMANAGEMENT_SUCCESS,
  payload: RADUserID,
});
export const deleteUserManagementFailure = (error) => ({
  type: types.DELETE_USERMANAGEMENT_FAILURE,
  payload: error,
});

export const saveUserManagementRequest = (userData, onSuccess = null) => ({
  type: types.SAVE_USERMANAGEMENT_REQUEST,
  payload: userData,
  onSuccess,
});
export const saveUserManagementSuccess = (user) => ({
  type: types.SAVE_USERMANAGEMENT_SUCCESS,
  payload: user,
});
export const saveUserManagementFailure = (error) => ({
  type: types.SAVE_USERMANAGEMENT_FAILURE,
  payload: error,
});

export const activateDeactivateUserManagementRequest = (
  RADUserID,
  status,
  modifiedBy,
) => ({
  type: types.ACTIVATE_DEACTIVATE_USERMANAGEMENT_REQUEST,
  payload: { userId: RADUserID, status, modifiedBy },
});
export const activateDeactivateUserManagementSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_USERMANAGEMENT_SUCCESS,
  payload: result,
});
export const activateDeactivateUserManagementFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_USERMANAGEMENT_FAILURE,
  payload: error,
});

export const fetchUserManagementByIdRequest = (userId, userType = null) => ({
  type: types.FETCH_USERMANAGEMENT_BY_ID_REQUEST,
  payload: { userId, userType },
});
export const fetchUserManagementByIdSuccess = (user) => ({
  type: types.FETCH_USERMANAGEMENT_BY_ID_SUCCESS,
  payload: user,
});
export const fetchUserManagementByIdFailure = (error) => ({
  type: types.FETCH_USERMANAGEMENT_BY_ID_FAILURE,
  payload: error,
});

export const resetUserMfaRequest = (userId, meta = {}) => ({
  type: types.RESET_USER_MFA_REQUEST,
  payload: { userId },
  meta,
});
export const resetUserMfaSuccess = (result) => ({
  type: types.RESET_USER_MFA_SUCCESS,
  payload: result,
});
export const resetUserMfaFailure = (error) => ({
  type: types.RESET_USER_MFA_FAILURE,
  payload: error,
});
// User Management Actions - End

//Holiday Planner Actions - start
export const fetchHolidayPlannerRequest = (year) => ({
  type: types.FETCH_HOLIDAY_PLANNER_REQUEST,
  payload: { year },
});
export const fetchHolidayPlannerSuccess = (data) => ({
  type: types.FETCH_HOLIDAY_PLANNER_SUCCESS,
  payload: data,
});
export const fetchHolidayPlannerFailure = (error) => ({
  type: types.FETCH_HOLIDAY_PLANNER_FAILURE,
  payload: error,
});

export const saveHolidayPlannerRequest = (holidayData) => ({
  type: types.SAVE_HOLIDAY_PLANNER_REQUEST,
  payload: holidayData,
});
export const saveHolidayPlannerSuccess = (holiday) => ({
  type: types.SAVE_HOLIDAY_PLANNER_SUCCESS,
  payload: holiday,
});
export const saveHolidayPlannerFailure = (error) => ({
  type: types.SAVE_HOLIDAY_PLANNER_FAILURE,
  payload: error,
});

export const deleteHolidayPlannerRequest = (
  HolidayID,
  modifiedBy,
  year,
  isCurrentYear,
  isFutureYear,
) => ({
  type: types.DELETE_HOLIDAY_PLANNER_REQUEST,
  payload: { HolidayID, modifiedBy, year, isCurrentYear, isFutureYear },
});
export const deleteHolidayPlannerSuccess = (HolidayID) => ({
  type: types.DELETE_HOLIDAY_PLANNER_SUCCESS,
  payload: HolidayID,
});
export const deleteHolidayPlannerFailure = (error) => ({
  type: types.DELETE_HOLIDAY_PLANNER_FAILURE,
  payload: error,
});

export const activateDeactivateHolidayPlannerRequest = (
  HolidayID,
  status,
  userId,
  year,
  isCurrentYear,
  isFutureYear,
) => ({
  type: types.ACTIVATE_DEACTIVATE_HOLIDAY_PLANNER_REQUEST,
  payload: { HolidayID, status, userId, year, isCurrentYear, isFutureYear },
});
export const activateDeactivateHolidayPlannerSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_HOLIDAY_PLANNER_SUCCESS,
  payload: result,
});
export const activateDeactivateHolidayPlannerFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_HOLIDAY_PLANNER_FAILURE,
  payload: error,
});

export const holidayPlannerBulkUpdateRequest = (data) => ({
  type: types.HOLIDAY_PLANNER_BULK_UPDATE_REQUEST,
  payload: data,
});
export const holidayPlannerBulkUpdateSuccess = (data) => ({
  type: types.HOLIDAY_PLANNER_BULK_UPDATE_SUCCESS,
  payload: data,
});
export const holidayPlannerBulkUpdateFailure = (error) => ({
  type: types.HOLIDAY_PLANNER_BULK_UPDATE_FAILURE,
  payload: error,
});
//Holiday Planner Actions - end

//Holiday Demand Planner Actions - Start
export const fetchHolidayDemandPlannerRequest = (payload) => ({
  type: types.FETCH_HOLIDAY_DEMANDPLANNER_REQUEST,
  payload,
});
export const fetchHolidayDemandPlannerSuccess = (data) => ({
  type: types.FETCH_HOLIDAY_DEMANDPLANNER_SUCCESS,
  payload: data,
});
export const fetchHolidayDemandPlannerFailure = (data) => ({
  type: types.FETCH_HOLIDAY_DEMANDPLANNER_FAILURE,
  payload: data,
});

export const templateDownloadHolidayDemandPlannerRequest = () => ({
  type: types.Template_DOWNLOAD_HOLIDAY_DEMANDPLANNER_REQUEST,
});
export const templateDownloadHolidayDemandPlannerSuccess = (data) => ({
  type: types.Template_DOWNLOAD_HOLIDAY_DEMANDPLANNER_SUCCESS,
  payload: data,
});
export const templateDownloadHolidayDemandPlannerFailure = (error) => ({
  type: types.Template_DOWNLOAD_HOLIDAY_DEMANDPLANNER_FAILURE,
  payload: error,
});
// Bulk Save Holiday Demand Planner
export const bulkSaveHolidayDemandPlannerRequest = (payload) => ({
  type: types.BULK_SAVE_HOLIDAY_DEMANDPLANNER_REQUEST,
  payload,
});
export const bulkSaveHolidayDemandPlannerSuccess = (data) => ({
  type: types.BULK_SAVE_HOLIDAY_DEMANDPLANNER_SUCCESS,
  payload: data,
});
export const bulkSaveHolidayDemandPlannerFailure = (error) => ({
  type: types.BULK_SAVE_HOLIDAY_DEMANDPLANNER_FAILURE,
  payload: error,
});

export const fetchRecentTrendHolidayDemandPlannerRequest = (payload) => ({
  type: types.FETCH_RECENT_TREND_HOLIDAY_DEMANDPLANNER_REQUEST,
  payload,
});
export const fetchRecentTrendHolidayDemandPlannerSuccess = (data) => ({
  type: types.FETCH_RECENT_TREND_HOLIDAY_DEMANDPLANNER_SUCCESS,
  payload: data,
});
export const fetchRecentTrendHolidayDemandPlannerFailure = (error) => ({
  type: types.FETCH_RECENT_TREND_HOLIDAY_DEMANDPLANNER_FAILURE,
  payload: error,
});

export const fetchPastTrendHolidayDemandPlannerRequest = (payload) => ({
  type: types.FETCH_PAST_TREND_HOLIDAY_DEMANDPLANNER_REQUEST,
  payload,
});
export const fetchPastTrendHolidayDemandPlannerSuccess = (data) => ({
  type: types.FETCH_PAST_TREND_HOLIDAY_DEMANDPLANNER_SUCCESS,
  payload: data,
});
export const fetchPastTrendHolidayDemandPlannerFailure = (error) => ({
  type: types.FETCH_PAST_TREND_HOLIDAY_DEMANDPLANNER_FAILURE,
  payload: error,
});

export const fetchHolidayDemandPlannerByIdRequest = (MappingHolidayDateID) => ({
  type: types.FETCH_HOLIDAY_DEMANDPLANNER_BY_ID_REQUEST,
  payload: { MappingHolidayDateID },
});

export const fetchHolidayDemandPlannerByIdSuccess = (data) => ({
  type: types.FETCH_HOLIDAY_DEMANDPLANNER_BY_ID_SUCCESS,
  payload: data,
});
export const fetchHolidayDemandPlannerByIdFailure = (error) => ({
  type: types.FETCH_HOLIDAY_DEMANDPLANNER_BY_ID_FAILURE,
  payload: error,
});
export const uploadSaveHolidayDemandPlannerRequest = (payload) => ({
  type: types.UPLOAD_SAVE_HOLIDAY_DEMANDPLANNER_REQUEST,
  payload,
});
export const uploadSaveHolidayDemandPlannerSuccess = (data) => ({
  type: types.UPLOAD_SAVE_HOLIDAY_DEMANDPLANNER_SUCCESS,
  payload: data,
});
export const uploadSaveHolidayDemandPlannerFailure = (error) => ({
  type: types.UPLOAD_SAVE_HOLIDAY_DEMANDPLANNER_FAILURE,
  payload: error,
});

export const logFileDownloadHolidayDemandPlannerRequest = (
  HolidayCoveragePastTrendFileID,
) => ({
  type: types.LOGFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_REQUEST,
  payload: { HolidayCoveragePastTrendFileID },
});
export const logFileDownloadHolidayDemandPlannerSuccess = (data) => ({
  type: types.LOGFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_SUCCESS,
  payload: data,
});
export const logFileDownloadHolidayDemandPlannerFailure = (error) => ({
  type: types.LOGFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_FAILURE,
  payload: error,
});

export const dataFileDownloadHolidayDemandPlannerRequest = (
  HolidayFileName,
) => ({
  type: types.DATAFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_REQUEST,
  payload: { HolidayFileName },
});
export const dataFileDownloadHolidayDemandPlannerSuccess = (data) => ({
  type: types.DATAFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_SUCCESS,
  payload: data,
});
export const dataFileDownloadHolidayDemandPlannerFailure = (error) => ({
  type: types.DATAFILE_DOWNLOAD_HOLIDAY_DEMANDPLANNER_FAILURE,
  payload: error,
});

//---------- Region Practice Actions Start ----------//
export const fetchRegionalPracticeRequest = () => ({
  type: types.FETCH_REGIONAL_PRACTICE_REQUEST,
});
export const fetchRegionalPracticeSuccess = (data) => ({
  type: types.FETCH_REGIONAL_PRACTICE_SUCCESS,
  payload: data,
});
export const fetchRegionalPracticeFailure = (error) => ({
  type: types.FETCH_REGIONAL_PRACTICE_FAILURE,
  payload: error,
});

export const deleteRegionalPracticeRequest = (
  RegionalPracticeID,
  CreatedBy,
) => ({
  type: types.DELETE_REGIONAL_PRACTICE_REQUEST,
  payload: { RegionalPracticeID, CreatedBy },
});
export const deleteRegionalPracticeSuccess = (RegionPracticeID) => ({
  type: types.DELETE_REGIONAL_PRACTICE_SUCCESS,
  payload: RegionPracticeID,
});
export const deleteRegionalPracticeFailure = (error) => ({
  type: types.DELETE_REGIONAL_PRACTICE_FAILURE,
  payload: error,
});

export const saveRegionalPracticeRequest = (regionPracticeData) => ({
  type: types.SAVE_REGIONAL_PRACTICE_REQUEST,
  payload: regionPracticeData,
});
export const saveRegionalPracticeSuccess = (regionPractice) => ({
  type: types.SAVE_REGIONAL_PRACTICE_SUCCESS,
  payload: regionPractice,
});
export const saveRegionalPracticeFailure = (error) => ({
  type: types.SAVE_REGIONAL_PRACTICE_FAILURE,
  payload: error,
});

export const fetchRegionalPracticeByIdRequest = (regionalPracticeId) => ({
  type: types.FETCH_REGIONAL_PRACTICE_BY_ID_REQUEST,
  payload: { regionalPracticeId },
});
export const fetchRegionalPracticeByIdSuccess = (regionPractice) => ({
  type: types.FETCH_REGIONAL_PRACTICE_BY_ID_SUCCESS,
  payload: regionPractice,
});
export const fetchRegionalPracticeByIdFailure = (error) => ({
  type: types.FETCH_REGIONAL_PRACTICE_BY_ID_FAILURE,
  payload: error,
});

export const activateDeactivateRegionalPracticeRequest = (
  regionalPracticeId,
  status,
  userId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_REQUEST,
  payload: { regionalPracticeId, status, userId },
});
export const activateDeactivateRegionalPracticeSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_SUCCESS,
  payload: result,
});
export const activateDeactivateRegionalPracticeFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_FAILURE,
  payload: error,
});
//---------- Region Practice Actions End ----------//

//----------Main Practice Actions start here----------//
export const fetchMainPracticeDataRequest = () => ({
  type: types.FETCH_MAIN_PRACTICE_REQUEST,
});

export const fetchMainPracticeDataSuccess = (data) => ({
  type: types.FETCH_MAIN_PRACTICE_SUCCESS,
  payload: data,
});

export const fetchMainPracticeDataFailure = (error) => ({
  type: types.FETCH_MAIN_PRACTICE_FAILURE,
  payload: error,
});

export const fetchGetAllMainPracticeDropdownListRequest = () => ({
  type: types.FETCH_MAIN_PRACTICE_DROPDOWNLIST_REQUEST,
});

export const fetchGetAllMainPracticeDropdownListSuccess = (data) => ({
  type: types.FETCH_MAIN_PRACTICE_DROPDOWNLIST_SUCCESS,
  payload: data,
});

export const fetchGetAllMainPracticeDropdownListFailure = (error) => ({
  type: types.FETCH_MAIN_PRACTICE_DROPDOWNLIST_FAILURE,
  payload: error,
});

export const saveMainPracticeRequest = (mainPracticeData) => ({
  type: types.SAVE_MAIN_PRACTICE_REQUEST,
  payload: mainPracticeData,
});

export const saveMainPracticeSuccess = (mainPractice) => ({
  type: types.SAVE_MAIN_PRACTICE_SUCCESS,
  payload: mainPractice,
});

export const saveMainPracticeFailure = (error) => ({
  type: types.SAVE_MAIN_PRACTICE_FAILURE,
  payload: error,
});

export const getMainPracticeByIdRequest = (payload) => ({
  type: types.GET_MAIN_PRACTICE_BY_ID_REQUEST,
  payload,
});

export const getMainPracticeByIdSuccess = (payload) => ({
  type: types.GET_MAIN_PRACTICE_BY_ID_SUCCESS,
  payload,
});

export const getMainPracticeByIdFailure = (error) => ({
  type: types.GET_MAIN_PRACTICE_BY_ID_FAILURE,
  payload: error,
});

export const deleteMainPracticeRequest = (MainPracticeID, modifiedBy) => ({
  type: types.DELETE_MAIN_PRACTICE_REQUEST,
  payload: { MainPracticeID, modifiedBy },
});

export const deleteMainPracticeSuccess = (MainPracticeID) => ({
  type: types.DELETE_MAIN_PRACTICE_SUCCESS,
  payload: MainPracticeID,
});

export const deleteMainPracticeFailure = (error) => ({
  type: types.DELETE_MAIN_PRACTICE_FAILURE,
  payload: error,
});

export const activatedeactivateMainPracticeRequest = (
  MainPracticeID,
  status,
  userId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_MAIN_PRACTICE_REQUEST,
  payload: { MainPracticeID, status, userId },
});

export const activatedeactivateMainPracticeSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_MAIN_PRACTICE_SUCCESS,
  payload: result,
});

export const activatedeactivateMainPracticeFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_MAIN_PRACTICE_FAILURE,
  payload: error,
});
//----------End of Main Practice Actions----------//

//Regional Practice Worklist Actions - start
export const fetchRegionalPracticeWorklistRequest = () => ({
  type: types.FETCH_REGIONAL_PRACTICE_WORKLIST_REQUEST,
});
export const fetchRegionalPracticeWorklistSuccess = (data) => ({
  type: types.FETCH_REGIONAL_PRACTICE_WORKLIST_SUCCESS,
  payload: data,
});
export const fetchRegionalPracticeWorklistFailure = (error) => ({
  type: types.FETCH_REGIONAL_PRACTICE_WORKLIST_FAILURE,
  payload: error,
});

export const deleteRegionalPracticeWorklistRequest = (
  RegionalPracticeWorklistID,
  CreatedBy,
) => ({
  type: types.DELETE_REGIONAL_PRACTICE_WORKLIST_REQUEST,
  payload: { RegionalPracticeWorklistID, CreatedBy },
});
export const deleteRegionalPracticeWorklistSuccess = (
  RegionalPracticeWorklistID,
) => ({
  type: types.DELETE_REGIONAL_PRACTICE_WORKLIST_SUCCESS,
  payload: RegionalPracticeWorklistID,
});
export const deleteRegionalPracticeWorklistFailure = (error) => ({
  type: types.DELETE_REGIONAL_PRACTICE_WORKLIST_FAILURE,
  payload: error,
});

export const saveRegionalPracticeWorklistRequest = (
  regionalPracticeWorklistData,
) => ({
  type: types.SAVE_REGIONAL_PRACTICE_WORKLIST_REQUEST,
  payload: regionalPracticeWorklistData,
});
export const saveRegionalPracticeWorklistSuccess = (
  regionalPracticeWorklist,
) => ({
  type: types.SAVE_REGIONAL_PRACTICE_WORKLIST_SUCCESS,
  payload: regionalPracticeWorklist,
});
export const saveRegionalPracticeWorklistFailure = (error) => ({
  type: types.SAVE_REGIONAL_PRACTICE_WORKLIST_FAILURE,
  payload: error,
});

export const fetchRegionalPracticeWorklistByIdRequest = (
  RegionalPracticeWorklistID,
  modifiedBy,
) => ({
  type: types.FETCH_REGIONAL_PRACTICE_WORKLIST_BY_ID_REQUEST,
  payload: { RegionalPracticeWorklistID, modifiedBy },
});
export const fetchRegionalPracticeWorklistByIdSuccess = (
  regionalPracticeWorklist,
) => ({
  type: types.FETCH_REGIONAL_PRACTICE_WORKLIST_BY_ID_SUCCESS,
  payload: regionalPracticeWorklist,
});
export const fetchRegionalPracticeWorklistByIdFailure = (error) => ({
  type: types.FETCH_REGIONAL_PRACTICE_WORKLIST_BY_ID_FAILURE,
  payload: error,
});

export const activateDeactivateRegionalPracticeWorklistRequest = (
  RegionalPracticeWorklistID,
  status,
  userId,
) => ({
  type: types.ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_WORKLIST_REQUEST,
  payload: { RegionalPracticeWorklistID, status, userId },
});
export const activateDeactivateRegionalPracticeWorklistSuccess = (result) => ({
  type: types.ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_WORKLIST_SUCCESS,
  payload: result,
});
export const activateDeactivateRegionalPracticeWorklistFailure = (error) => ({
  type: types.ACTIVATE_DEACTIVATE_REGIONAL_PRACTICE_WORKLIST_FAILURE,
  payload: error,
});

export const dropdownRegionalPracticeRequest = () => ({
  type: types.DROPDOWN_REGIONAL_PRACTICE_REQUEST,
});
export const dropdownRegionalPracticeSuccess = (data) => ({
  type: types.DROPDOWN_REGIONAL_PRACTICE_SUCCESS,
  payload: data,
});
export const dropdownRegionalPracticeFailure = (error) => ({
  type: types.DROPDOWN_REGIONAL_PRACTICE_FAILURE,
  payload: error,
});
//Regional Practice Worklist Actions - end

// Update Admin Reducer
export const updateAdminReducer = (data) => ({
  type: types.UPDATE_ADMIN_REDUCER,
  payload: data,
});

// WorkList full save (worklist + practiceMode + facilities)
export const saveWorklistFullRequest = (data) => ({
  type: types.SAVE_WORKLIST_FULL_REQUEST,
  payload: data,
});
export const saveWorklistFullSuccess = () => ({
  type: types.SAVE_WORKLIST_FULL_SUCCESS,
});
export const saveWorklistFullFailure = (error) => ({
  type: types.SAVE_WORKLIST_FULL_FAILURE,
  payload: error,
});
